exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__2CHG {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column; }\n\n.heading__heJN {\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 5px; }\n\n.subHeading__2nMi {\n  font-size: 14px; }\n", "", {"version":3,"sources":["/app/src/fonts/font-picker/font-list/src/fonts/font-picker/font-list/font-not-found.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB,EACxB;;AAED;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB,EACpB;;AAED;EACE,gBAAgB,EACjB","file":"font-not-found.scss","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.heading {\n  font-size: 15px;\n  font-weight: 500;\n  margin-bottom: 5px;\n}\n\n.subHeading {\n  font-size: 14px;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__2CHG",
	"heading": "heading__heJN",
	"subHeading": "subHeading__2nMi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/fonts/font-picker/font-list/font-not-found.scss
// module id = 1406
// module chunks = 0